export const getMinPrice = (priceDenominations) => {
    // Ensure priceDenominations is a string
    const pricesArray = String(priceDenominations)?.split(",");

    // Convert the array of strings to an array of numbers
    const pricesNumbers = pricesArray?.map(Number);

    // Find and return the minimum price
    return Math.min(...pricesNumbers);
  };